// extracted by mini-css-extract-plugin
export default {"title":"InfoMessage_title__yrYqv","error":"InfoMessage_error__YsSq0","info":"InfoMessage_info__a272Y"};